import React, { useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';

import {
    normalizeFields,
    filterOnChange,
    shouldNotReRender,
} from './utils';
import FilterComponent from '../Filter';

const Filter = (props) => {

    const {
        fieldsData,
        filterConfig,
        activeFilters,
        addSelectedFilter,
        removeSelectedFilter,
    } = props;

    const fields = useMemo(() => normalizeFields(filterConfig, fieldsData, activeFilters), [
        filterConfig,
        fieldsData,
        activeFilters,
    ]);
    const filterOnChangeHandler = useCallback((data, field) => {

        return filterOnChange(data, field, addSelectedFilter, removeSelectedFilter);

    }, [
        addSelectedFilter,
        removeSelectedFilter,
    ]);

    return (
        <FilterComponent
            type={filterConfig.component}
            fields={fields}
            onChange={filterOnChangeHandler}
            componentConfig={filterConfig.componentConfig}
            filterName={filterConfig.filterName}
        />
    );

};

Filter.propTypes = {
    fieldsData: PropTypes.array.isRequired,
    filterConfig: PropTypes.object.isRequired,
    activeFilters: PropTypes.array.isRequired,
    addSelectedFilter: PropTypes.func.isRequired,
    removeSelectedFilter: PropTypes.func.isRequired,
};

export default React.memo(Filter, shouldNotReRender);
